import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from '../../services/api';

const name = 'deleteFeedbackOption';
const initialState = createInitialState();

function createInitialState() {
    return {
        done: false,
        error: false,
        spinner: false,
        deleteFeedbackOption: null,
    };
}

export const deleteFeedbackOption = createAsyncThunk('deleteFeedbackOption', async (id, { rejectWithValue }) => {
    try {
        const response = await api.delete(`/super/api/feedback/option/delete/${id}`);
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response.data);
    }
});

const deleteFeedbackOptionSlice = createSlice({
    name: name,
    initialState,
    reducers: {
        resetDeleteFeedbackOption: state => {
            state.done = false;
            state.error = false;
            state.spinner = false;
            state.deleteFeedbackOption = null;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(deleteFeedbackOption.pending, state => {
                state.spinner = true;
                state.error = false;
            })
            .addCase(deleteFeedbackOption.fulfilled, (state, action) => {
                state.done = true;
                state.spinner = false;
                state.error = false;
                state.deleteFeedbackOption = action.payload;
            })
            .addCase(deleteFeedbackOption.rejected, (state, action) => {
                state.done = false;
                state.spinner = false;
                state.error = action.payload;
            });
    },
});

export const { resetDeleteFeedbackOption } = deleteFeedbackOptionSlice.actions;
export const deleteFeedbackOptionReducer = deleteFeedbackOptionSlice.reducer;
